export const ROLES_PARTE = [
    "fideicomitente",
    "fideicomisario_primer_lugar",
    "fideicomisario_ultimo_lugar",
    "delegado_fiduciario",
    "miembro_comite_tecnico",
    "firmante_autorizado",
    "asesor",
    "obligado_solidario",
];

export const ROLES_PARTE_LABELS = {
    fideicomitente: "Fideicomitente",
    fideicomisario_primer_lugar: "Fideicomisario 1er lugar",
    fideicomisario_ultimo_lugar: "Fideicomisario último lugar",
    delegado_fiduciario: "Delegado fiduciario",
    miembro_comite_tecnico: "Miembro comité técnico",
    firmante_autorizado: "Firmante autorizado",
    asesor: "Asesor",
    obligado_solidario: "Obligado solidario",
};

export const TIPOS_FIDEICOMISO = [
    { value: "garantia", label: "Garantía" },
    { value: "administracion", label: "Administración" },
    { value: "fuente_pago", label: "Fuente de pago" },
    { value: "escrow", label: "Escrow" },
    { value: "inversion", label: "Inversión" },
    { value: "inmobiliario", label: "Inmobiliario" },
    { value: "emision", label: "Emisión" },
    { value: "planes_empleados", label: "Planes empleados" },
    { value: "patrimonial", label: "Patrimonial" },
];

export const ESTADOS_CICLO = [
    { value: "en_constitucion", label: "En constitución", tone: "warning" },
    { value: "activo", label: "Activo", tone: "success" },
    { value: "en_modificacion", label: "En modificación", tone: "warning" },
    { value: "en_extincion", label: "En extinción", tone: "danger" },
    { value: "extinguido", label: "Extinguido", tone: "muted" },
];

export const VERTICALES = [
    { value: "v1_garantia", label: "V1 · Garantía" },
    { value: "v2_administracion", label: "V2 · Administración" },
    { value: "v3_escrow", label: "V3 · Escrow" },
    { value: "v4_inversion", label: "V4 · Inversión" },
    { value: "v5_inmobiliario", label: "V5 · Inmobiliario" },
    { value: "v6_emision", label: "V6 · Emisión" },
];

export const DOC_TAXONOMIA = [
    { value: "contrato", label: "Contrato" },
    { value: "convenio_modificatorio", label: "Convenio modificatorio" },
    { value: "acta_comite", label: "Acta de comité" },
    { value: "instruccion", label: "Instrucción" },
    { value: "acuse", label: "Acuse" },
    { value: "avaluo", label: "Avalúo" },
    { value: "poliza_seguro", label: "Póliza de seguro" },
    { value: "kyc", label: "KYC" },
    { value: "estado_cuenta", label: "Estado de cuenta" },
    { value: "reporte_lenders", label: "Reporte a lenders" },
    { value: "otros", label: "Otros" },
];

export const KYC_DOCS_FISICA = [
    "identificacion_oficial",
    "comprobante_domicilio",
    "constancia_rfc",
    "curp",
    "referencias",
];
export const KYC_DOCS_MORAL = [
    "acta_constitutiva",
    "poderes_representante",
    "constancia_rfc",
    "comprobante_domicilio_fiscal",
    "estados_financieros",
    "cuestionario_kyc",
];

export const LISTA_TIPOS = [
    { value: "pep", label: "PEP" },
    { value: "ofac", label: "OFAC" },
    { value: "interpol", label: "Interpol" },
    { value: "nacional", label: "Nacional" },
];

export function labelTipo(value, catalog) {
    return catalog.find((x) => x.value === value)?.label || value;
}
